import React from "react";
import { useTranslation } from "react-i18next";
import { IJobStateUploadToCloudLibrary } from "@/types";
import { SongItem } from "./SongItem";
import { Button } from "./ui/button";
import { shell } from "electron";

interface Props {
  job: IJobStateUploadToCloudLibrary;
}

export function ListItemJobUploadToCloudLibrary({ job }: Props) {
  const { t } = useTranslation();

  function handleClick() {
    if (!job.output) return;
    const url = `https://online.youka.io/library?kid=${job.output.karaokeId}`;
    shell.openExternal(url);
  }

  return (
    <SongItem
      song={job.input.song}
      job={job}
      variant="notification"
      // @ts-ignore
      subtitle={t(job.name) || job.name}
    >
      {job.output && (
        <Button variant="outline" onClick={handleClick}>
          {t("Show")}
        </Button>
      )}
    </SongItem>
  );
}
